import { useTranslation } from "react-i18next";

import { Link, Spacer, Typography } from "@aviary";
import { l } from "@shared/locales/i18n";
import type { TwoFactorAuthenticationMethods } from "@shared/types/graphqlGenerated";

interface Props {
  otpMethod: TwoFactorAuthenticationMethods;
  onClick: () => void;
}

const BackupCodeSignInLink = ({ otpMethod, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography type="footnote" isMarginless>
        {t(l.mfa.VerifyMFAForm.unableToAccessOtpMethod[otpMethod])}
      </Typography>
      <Spacer height="half" />
      <Typography type="footnote">
        {/* eslint-disable-next-line react-compiler/react-compiler */}
        <Link onClick={onClick}>{t(l.mfa.VerifyMFAForm.useBackupCodeToSignIn)}</Link>
      </Typography>
      <Spacer height="oneHalf" />
    </>
  );
};

export { BackupCodeSignInLink };
